function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import * as actions from '../../actions';
import messages from '../../messages';
import styles from '../../components/DownloadDataModal/DownloadDataModal.pcss';
const NoConnection = ({ onSetComponent })=>{
    const { downloader: downloaderContext } = useContext(AppContext);
    const installDownloader = useAction(actions.installDownloader);
    const onInstall = ()=>{
        onSetComponent('InstallingDownloader');
        installDownloader();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.noConnection.header))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.noConnection.info))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/no-connection.svg",
                    className: "w-100",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "modal__actions",
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "link",
                    to: downloaderContext.installUrl,
                    styleModifier: "primary",
                    labelMessage: messages.buttons.runReinstallDownloader,
                    className: "btn--block btn--filled",
                    onClick: onInstall
                })
            })
        ]
    });
};
export default NoConnection;
